import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { rankingOffersStyle, info } from "./style";
import ItemRankingOffers from "./ItemRankingOffers";
import { floatFormat, formatCurrency } from "../utils/formats";
import { useNewOffer } from "../../../js/context/new-offer";

const RankingOffers = ({ mobile, editMobile }) => {
	const [ranking, setRanking] = useState([]);
	const [offer, setOffer] = useState({});

	const { rankingData, offerData, pricesData, setPositionRank } = useNewOffer();

	useEffect(() => {
		const { minMiles, maxMiles, minPrice, maxPrice } = pricesData.data;

		const newPrice = parseFloat(offerData.data.price) ? floatFormat(offerData.data.price) : 0;
		const newMiles = parseInt(offerData.data.quant) ? parseInt(offerData.data.quant) : 0;
		const ruleToShowRanking =
			newPrice >= minPrice && newPrice <= maxPrice && newMiles >= minMiles && newMiles <= maxMiles;

		if (!ruleToShowRanking) {
			setRanking([]);
			return;
		}

		let newRanking = [];
		let price = floatFormat(String(offerData.data.price));
		let currentPrice = formatCurrency(offerData.data.price);
		let newPriceStatus = false;
		if (rankingData.data.rank && rankingData.data.rank.length) {
			rankingData.data.rank.map((item, i) => {
				let priceAux = floatFormat(item.price);
				if (price < priceAux && !newPriceStatus) {
					let position = item.position;
					position = position <= 50 ? position : 50;
					newRanking.push({ position: position, price: currentPrice, userOffer: true });
					newRanking.push({ position: position + 1, price: item.price, name: item.name });
					setOffer({ position: position, price: currentPrice, userOffer: true });
					setPositionRank(position);
					newPriceStatus = true;
				} else if (item.position !== undefined) {
					newRanking.push({
						position: newPriceStatus ? item.position + 1 : item.position,
						price: item.price,
						name: item.name
					});
					if (rankingData.data.rank.length === i + 1 && !newPriceStatus) {
						let position = rankingData.data.rank.length > 4 ? i + 1 : i + 2;
						position = position <= 50 ? position : 50;
						newRanking.push({ position: position, price: currentPrice, userOffer: true });
						setOffer({
							position: ">" + position,
							price: currentPrice,
							userOffer: true
						});
						setPositionRank(">" + position);
					}
				}
			});
		}
		setRanking(newRanking);
	}, [rankingData, offerData]);

	const rows = editMobile ? 3 : 5;

	const renderRanking =
		offer.position < rows
			? ranking.slice(0, rows).map((item, i) => {
					return <ItemRankingOffers key={i} item={item} userOffer={item.userOffer} />;
			  })
			: ranking.slice(0, rows - 1).map((item, i) => {
					return (
						<>
							<ItemRankingOffers key={i} item={item} userOffer={item.userOffer} />
							{i + 1 === rows - 1 && (
								<ItemRankingOffers key={i + 1} item={offer} userOffer={offer.userOffer} />
							)}
						</>
					);
			  });

	return !!mobile && rankingData.data.rank && rankingData.data.rank.length ? (
		<>
			<p className="title--ranking">Ranking de ofertas</p>
			<div
				className={css`
					${rankingOffersStyle}
				`}
			>
				{renderRanking}
			</div>
			<p
				className={css`
					${info}
				`}
			>
				O valor indicado por você define sua posição em nosso <strong>ranking de ofertas</strong>.
				Quanto melhor a posição no ranking, mais rápidas serão suas vendas.
			</p>
		</>
	) : (
		<div
			className={css`
				${rankingOffersStyle}
			`}
		>
			{renderRanking}
		</div>
	);
};

export default RankingOffers;
